import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  description: {
    lineHeight: Theme.px(40),
  },
  focusHandle: {
    height: 1,
    opacity: 0,
    width: 1,
  },
  scrollView: {
    height: Theme.px(650),
    paddingRight: Theme.px(30),
  },
  title: {
    marginBottom: Theme.px(30),
  },
  wrapper: {
    backgroundColor: Theme.colorFocusText,
    borderRadius: Theme.px(24),
    height: Theme.px(848),
    paddingBottom: Theme.px(40),
    paddingLeft: Theme.px(60),
    paddingRight: Theme.px(40),
    paddingTop: Theme.px(53),
    width: Theme.px(1160),
  },
});
